import { render, staticRenderFns } from "./medium.vue?vue&type=template&id=018dfc21&lang=pug"
import script from "./medium.vue?vue&type=script&lang=js"
export * from "./medium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports